import _ from 'lodash';

import { createAction } from 'redux-actions';
import { createSelector } from 'reselect';

import SwaggerAPI from 'data/SwaggerAPI';
const SET_SELECTED_DEVICE = 'properties/SET_SELECTED_DEVICE';
const CREATE_DEVICE = 'properties/CREATE_DEVICE';
const UPDATE_DEVICES = 'properties/UPDATE_DEVICES';
const RECEIVE_DEVICES = 'properties/RECEIVE_DEVICES';
const FETCHING_DEVICES = 'properties/FETCHING_DEVICES';
const initialState = {
  devices: [],
  selectedDevice: undefined,
  isFetchingDevices: false,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCHING_DEVICES: {
      return {
        ...state,
        isFetchingDevices: true,
      };
    }
    case SET_SELECTED_DEVICE: {
      if (action.device === state.selectedDevice) return state;
      return {
        ...state,
        selectedDevice: action.device,
        isFetchingDevices: false,
      };
    }
    case CREATE_DEVICE: {
      const device = action.payload;
      const fieldDevices = state.devices;
      const updated = [...fieldDevices, device];
      return {
        ...state,
        devices: updated,
        isFetchingDevices: false,
      };
    }
    case UPDATE_DEVICES: {
      const devicesCopy = _.clone(state.devices);
      const devices = action.payload;
      if (devices) {
        for (const device of devices) {
          const index = _.findIndex(devicesCopy, { id: device.id });
          devicesCopy[index] = device;
        }
      }

      return {
        ...state,
        devices: devicesCopy,
        isFetchingDevices: false,
      };
    }
    case RECEIVE_DEVICES: {
      if (!action.payload) return state;
      if (action.error) {
        return {
          ...state,
          error: action.payload,
          isFetchingDevices: false,
        };
      }
      const newDevices = _.clone(state.devices);
      _.forEach(action.payload, (device) => {
        const index = _.findIndex(newDevices, { id: device.id });
        if (index === -1) {
          newDevices.push(device);
        } else {
          newDevices[index] = device;
        }
      });

      return {
        ...state,
        devices: newDevices,
        isFetchingDevices: false,
      };
    }
    default:
      return state;
  }
};

const Devices = (function () {
  const startFetch = () => ({ type: FETCHING_DEVICES });
  const setSelectedDevice = (device) => ({ type: SET_SELECTED_DEVICE, device });
  const createDevice = createAction(CREATE_DEVICE, SwaggerAPI.deviceCreate);
  const fetchDevices = createAction(RECEIVE_DEVICES, SwaggerAPI.deviceList);
  const updateDevices = createAction(UPDATE_DEVICES, SwaggerAPI.devicesUpdate);
  const getIsFetchingDevices = (state) => state.devices.isFetchingDevices;
  const getActiveDevice = (state) => state.devices.selectedDevice;
  const getDevices = (state) => state.devices.devices;
  const getFields = (state) => state.fields.fields;
  const getSelectedPropertyId = (state) => state.properties.selectedProperty;
  const getSelectedOrganizationId = (state) => state.organizations.selectedOrganization?.id;
  const getSelectedFieldId = (state) => state.fields.selectedField?.id;
  const getProperties = (state) => state.properties.properties;

  const getDevicesWithFieldNameList = createSelector([getDevices, getFields, getProperties], (devices, fields) => {
    const devicesWithDetails = [];

    if (devices != undefined) {
      _.forEach(devices, (device) => {
        const field = _.find(fields, { id: device.field_id });
        if (field?.property_id !== undefined) {
          device.property_id = field.property_id;
        } else {
          device.property_id = -3;
        }
        if (field?.name != undefined) {
          device.field_name = field.name;
        } else {
          device.field_name = 'No Field';
        }
        if ('field_id' in device) {
          if (device.field_id === undefined) {
            device.field_id = -2;
          }
        } else {
          device.field_id = -2;
        }
        devicesWithDetails.push(device);
      });
    }
    return devicesWithDetails;
  });

  const getSelectedDevices = createSelector(
    [getDevicesWithFieldNameList, getSelectedOrganizationId, getSelectedPropertyId, getSelectedFieldId],
    (devices, orgId, propId, fieldId) => {
      let selectedDevices = [];
      if (fieldId) {
        _.forEach(devices, (device) => {
          if (device.field_id === fieldId) {
            selectedDevices.push(device);
          }
        });
      } else if (propId) {
        _.forEach(devices, (device) => {
          if (device.property_id === propId) {
            selectedDevices.push(device);
          }
        });
      } else if (orgId) {
        _.forEach(devices, (device) => {
          if (device.organization_id === orgId) {
            selectedDevices.push(device);
          }
        });
      } else {
        selectedDevices = selectedDevices.concat(devices);
      }

      return selectedDevices;
    }
  );

  return {
    startFetch,
    setSelectedDevice,
    getDevices,
    getDevicesWithFieldNameList,
    getActiveDevice,
    fetchDevices,
    createDevice,
    updateDevices,
    getSelectedDevices,
    getIsFetchingDevices,

    SET_SELECTED_DEVICE,
  };
})();

export default Devices;
